<template>
  <div>
    <van-nav-bar
      :fixed="true"
      title="客户回访"
      left-arrow
      @click-left="$router.back()"
    />

    <div class="info">
      <van-cell
        :title="userinfo.客户姓名"
        :value="userinfo.客户电话| maskTel"
        :label="userinfo.客户地址"
      
       
      />
      <van-cell title="备注" :label="userinfo.备注" />
      <van-cell
        title="登记日期"
        :value="userinfo._createtime | parseTime('{y}-{m}-{d} {h}:{i}')"
      />

      <van-cell
        title="最近回访"
        :value="userinfo._updatetime | parseTime('{y}-{m}-{d} {h}:{i}')"
      />
      <van-collapse v-model="activeNames" accordion>
        <van-collapse-item title="调查问卷" name="1">
          <van-cell
            v-for="(v, i) in userinfo.调查问卷"
            :key="i"
            :title="v.title"
            :value="v.value"
          />
        </van-collapse-item>

        <van-collapse-item title="回访历史" name="2">
          <van-cell
            v-for="(v, i) in userinfo.回访记录"
            :key="i"
           
            :title="v.回访时刻 | parseTime('{y}-{m}-{d}  {h}:{i}')"
            :value="v.备注"
          />
        </van-collapse-item>
      </van-collapse>
      <van-cell-group>
        <van-field
          v-model="备注"
          label="回访反馈"
          placeholder="请填写回访内容"
          required
        />
      </van-cell-group>
      <div style="margin: 16px">
        <van-row>
          <van-col span="24">
            <!-- <van-button
              round
              block
             
              native-type="submit"
              @click.prevent="onTel()"
              >拨打电话</van-button
            > -->
            <a :href="'tel:'+userinfo.客户电话" class="calltel"> <van-icon name="phone-o" /> {{userinfo.客户电话| maskTel}}</a>
          </van-col>
          
        </van-row>
      </div>
      <div style="margin: 16px">
        <van-row>
         
          <van-col span="12">
            <van-button round block @click.prevent="$router.back()"
              >取消</van-button
            >
          </van-col>
          
          <van-col span="12">
            <van-button
              round
              block
              type="info"
              native-type="submit"
              @click.prevent="onSubmit"
              >提交</van-button
            >
          </van-col>
        </van-row>
      </div>
      <van-popup v-model="showPopup" position="bottom">
      <van-picker
        title="请选择"
        show-toolbar
        :columns="popupList"
        @cancel="showPopup = false"
        @confirm="onPopupConfirm"
      />
    </van-popup>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";

export default {
  name: "edit",
  props: {},
  data() {
    return {
      id: "",
      备注: "",
      userinfo: {},
      showPopup:false,
      activeNames: "",
      //returnvisitList: [],
    };
  },

  created() {
    var tel = this.$route.params.tel;
    console.log("tel", tel);
    this.$request.customerByTel({ tel: tel , project: localStorage.getItem("projectname"),}).then((res) => {
      if (res.code == 0) {
        this.userinfo = res.data;
        // this.$request
        //   .returnvisitList({ req: { uid: this.userinfo._id } })
        //   .then((res) => {
        //     if (res.code == 0) {
        //       this.returnvisitList = res.data.items;
        //     }
        //   });
      }
    });
  },
  methods: {
    //调查问卷
    ShowPopub(index) {
      this.showPopup = true;
      this.popubIndex = index;
      this.popupList = this.questionnaire[index].list;
    },
    onPopupConfirm(value) {
      var title = this.questionnaire[this.popubIndex].title;
      this.append[title] = { title, value };
      this.showPopup = false;
    },

    onSubmit(values) {
      let data = {
        
        客户电话: this.userinfo.客户电话,
        备注: this.备注,
      };

      this.$request.returnvisitSave(data).then((res) => {
        if (res.code == 0) {
          Toast("保存成功！");
          this.$router.back();
        }
      });
    },
    goEdit() {
      this.$router.push("/crmregister/" + this.id);
    },
    onTel(){
      
    },
  },
  components: {},
};
</script>
<style scoped lang="less">
// .van-cell {
//   margin: 0px;
//   padding: 0px;
// }
.info {
  font-size: 14px;
  // margin: 5px;
  margin-top: 50px;
  span {
    font-size: 12px;
  }
}
.edit {
  box-sizing: border-box;
  padding: 10px;
  background: #fff;
}
.calltel{
  text-align: center;
  line-height: 32px;
  font-size: 24px;
  background-color: goldenrod;
  color: white;
  border-radius: 5px;
}
</style>